import gql from 'graphql-tag';

export const GQL_UPLOAD_ASSET = gql`
	mutation uploadAsset($file: Upload!) {
		uploadAsset(file: $file) {
			asset {
				id
				url
			}
		}
	}
`;
